<template>
  <v-card class="lurchcard rounded-xl" dark height="100%">
    <v-container>
      <v-row
        align="center"
        justify="center"
        class="text-center mt-auto mb-auto"
      >
        <v-col cols="12">
          <v-avatar size="200">
            <img
              :src="require('../assets/AXOgamingLOGOintense.gif')"
              alt="Lurchus Maximus"
              contain
              height="200"
            />
          </v-avatar>
        </v-col>
      </v-row>
      <v-row
        align="center"
        justify="center"
        class="text-center mt-auto mb-auto"
      >
        <v-col cols="12">
          <h1 class="text-h3 font-weight-thin mb-4">Willkommen!</h1>
          <h4
            class="text-h5 breaktext"
            color="blue lighten-5"
          >
            schwanzlurch.net ist eine Discord Community in der sich Gamer und
            andere Mitglieder austauschen können.
          </h4>
          <v-btn class="mt-9" :href="discordLink" target="_blank" outlined x-large>
            <span class="mr-2">Discord beitreten</span>
            <v-icon>mdi-discord</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: 'MainCard',

  data: () => ({
    discordLink: 'https://discord.gg/HW2DrvNB3P',
  }),
}
</script>
<style>
html {
  font-size: 16px;
}
.breaktext {
  line-break: strict;
}
.lurchcard {
  background: linear-gradient(
    rgba(180, 0, 0, 0.76),
    rgba(47, 46, 46, 0.65)
  ) !important;
}
</style>
